import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormFieldInputComponent } from './dhl-form/components/form-field-input/form-field-input.component';
import { FormFieldTableComponent } from './dhl-form/components/form-field-table/form-field-table.component';
import { FormFieldDropDownComponent } from './dhl-form/components/form-field-dropdown/form-field-dropdown.component';
import { FormFieldDatePickerComponent } from './dhl-form/components/form-field-datepicker/form-field-datepicker.component';
import { FormFieldAutoCompleteComponent } from './dhl-form/components/form-field-autocomplete/form-field-autocomplete.component';
import { FormFieldLocationComponent } from './dhl-form/components/form-field-location/form-field-location.component';
import { FormSearchBoxComponent } from './dhl-form/components/form-search-box/form-search-box.component';
import { FormTableListComponent } from './dhl-form/components/form-table-list/form-table-list.component';
import { FormDialogBoxComponent } from './dhl-form/components/form-dialog-box/form-dialog-box.component';
import { SnackBarComponent } from '../common/snack-bar/snack-bar.component';
import { FormFieldHiddenComponent } from './dhl-form/components/form-field-hidden/form-field-hidden.component';
import { ModalComponent } from '../common/modal/modal.component';
import { FormComponent } from './dhl-form/components/form/form.component';
import { FormFieldComponent } from './dhl-form/components/form-field/form-field.component';
import { FormFieldCardComponent } from './dhl-form/components/form-field-card/form-field-card.component';
import { FormFieldSlideToggleComponent } from './dhl-form/components/form-field-slide-toggle/form-field-slide-toggle.component';
import { FormFieldFilterComponent } from './dhl-form/components/form-field-filter/form-field-filter.component';
import { HereMapComponent } from './dhl-form/components/here-map/here-map.component';
import { DemoMaterialModule } from 'src/material.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CheckErrorPipe } from '../common/check-error-pipe';
import { AppOrderFilterComponent } from '../app-order/app-order-filter/app-order-filter.component';
import { FormFieldButtonToggleComponent } from './dhl-form/components/form-field-button-toggle/form-field-button-toggle.component';
import { FormFieldWrapperComponent } from './dhl-form/components/form-field-wrapper/form-field-wrapper.component';
import { FormFieldChipsAutocompleteComponent } from './dhl-form/components/form-field-chips-autocomplete/form-field-chips-autocomplete.component';
import { FormFieldFileUploadComponent } from './dhl-form/components/form-field-file-upload/form-field-file-upload.component';
import { FormFieldFileDownloadComponent } from './dhl-form/components/form-field-file-download/form-field-file-download.component';
import { AppExtendWidthHeightDirective } from './dhl-form/components/form-table-list/app-extend-width-height.directive';
import { FormTableComponent } from './dhl-form/components/form-table/form-table.component';
import { VerticalStepperComponent } from '../common/vertical-stepper/vertical-stepper.component';
// POC code
import { HorizontalStepperV2Component } from './common/horizontal-stepper-v2/horizontal-stepper-v2.component';
import { StepperContentComponent } from './common/stepper-content/stepper-content.component';
import { FormFieldInputV2Component } from './dhl-form/components-v2/form-field-input-v2/form-field-input-v2.component';
import { FormFieldToggleSwitchV2Component } from './dhl-form/components-v2/form-field-toggle-switch-v2/form-field-toggle-switch-v2.component';
import { FormFieldSpaceholderV2Component } from './dhl-form/components-v2/form-field-spaceholder-v2/form-field-spaceholder-v2.component';
import { FormFieldTextareaV2Component } from './dhl-form/components-v2/form-field-textarea-v2/form-field-textarea-v2.component';
import { SearchBoxV2Component } from './common/search-box-v2/search-box-v2.component';
import { GenericTableV2Component } from './common/generic-table-v2/generic-table-v2.component';
import { FormFieldDropdownMultiChoiceV2Component } from './dhl-form/components-v2/form-field-dropdown-multi-choice-v2/form-field-dropdown-multi-choice-v2.component';
import { FormFieldDropdownMultiOptionIconV2Component } from './dhl-form/components-v2/form-field-dropdown-multi-option-icon-v2/form-field-dropdown-multi-option-icon-v2.component';
import { FormFieldInputDirective } from './dhl-form/directives/form-field-input.directive';
import { FormFieldDropdownDirective } from './dhl-form/directives/form-field-dropdown.directive';
import { GenericFilterV2Component } from './common/generic-filter-v2/generic-filter-v2.component';
import { GenericFormFilterV2Component } from './common/generic-form-filter-v2/generic-form-filter-v2.component';
import { ProgressIndicatorV2Component } from './common/progress-indicator-v2/progress-indicator-v2.component';
import { FormFieldDropdownDefaultV2Component } from './dhl-form/components-v2/form-field-dropdown-default-v2/form-field-dropdown-default-v2.component';
import { FormFieldDatepickerV2Component } from './dhl-form/components-v2/form-field-datepicker-v2/form-field-datepicker-v2.component';
import { FormFieldDatepickerV2Directive } from './dhl-form/components-v2/form-field-datepicker-v2/form-field-datepicker-v2.directive';
import { FormFieldGenericV2Component } from './dhl-form/components-v2/form-field-generic-v2/form-field-generic-v2.component';
import { FormFieldGenericDirective } from './dhl-form/components-v2/form-field-generic-v2/form-field-generic.directive';
import { FormFieldDateRangeV2Component } from './dhl-form/components-v2/form-field-date-range-v2/form-field-date-range-v2.component';
import { DatepickerFilterV2Component } from './common/datepicker-filter-v2/datepicker-filter-v2.component';
import { SubformComponent } from './dhl-form/components-v2/subform/subform.component';
import { GenericAccordionV2Component } from './common/generic-accordion-v2/generic-accordion-v2.component';
import { GenericAccordionGroupV2Component } from './common/generic-accordion-group-v2/generic-accordion-group-v2.component';

import { FormFieldTableV2Component } from './dhl-form/components-v2/form-field-table-v2/form-field-table-v2.component';
import { FormFieldLocationV2Component } from './dhl-form/components-v2/form-field-location-v2/form-field-location-v2.component';
import { FormFieldAutocompleteV2Component } from './dhl-form/components-v2/form-field-autocomplete-v2/form-field-autocomplete-v2.component';
import { FormFieldAutocompleteV2Directive } from './dhl-form/components-v2/form-field-autocomplete-v2/form-field-autocomplete-v2.directive'
import { FormFieldAutoPoItemcompleteV2Component } from './dhl-form/components-v2/form-field-po-item-autocomplete-v2/form-field-po-item-autocomplete-v2.component';
import { FormFieldLocationAutocompleteV2Component } from './dhl-form/components-v2/form-field-location-autocomplete-v2/form-field-location-autocomplete-v2.component';
import { FormFieldOrderLineAutocompleteComponent } from './dhl-form/components-v2/form-field-order-line-autocomplete-v2/form-field-order-line-autocomplete-v2.component';
import { GenericFormFieldGroupV2Component } from './common/generic-form-field-group-v2/generic-form-field-group-v2.component';
import { GenericModalV2Component } from './common/generic-modal-v2/generic-modal-v2.component';
import { FormFieldReadonlyV2Component } from './dhl-form/components-v2/form-field-readonly-v2/form-field-readonly-v2.component';
import { FormFieldGenericAutocompleteV2Component } from './dhl-form/components-v2/form-field-generic-autocomplete-v2/form-field-generic-autocomplete-v2.component';
import { FormSectionV2Component } from './dhl-form/components-v2/form-section-v2/form-section-v2.component';
import { OverviewV2Component } from './common/overview-v2/overview-v2.component';
import { FormFieldDropdownSimpleV2Component } from './dhl-form/components-v2/form-field-dropdown-simple-v2/form-field-dropdown-simple-v2.component';
import { FormFieldCheckboxV2Component } from './dhl-form/components-v2/form-field-checkbox-v2/form-field-checkbox-v2.component';
import { FormFieldDropdownMultiselectV2Component } from './dhl-form/components-v2/form-field-dropdown-multiselect-v2/form-field-dropdown-multiselect-v2.component';
import { GenericNotesV2Component } from './dhl-form/components-v2/generic-notes-v2/generic-notes-v2.component';
import { OverviewItemV2Component } from './common/overview-item-v2/overview-item-v2.component';
import { OverviewLocationV2Component } from './common/overview-location-v2/overview-location-v2.component';
import { OverviewGenericV2Component } from './common/overview-generic-v2/overview-generic-v2.component';
import { OverviewStatusV2Component } from './common/overview-status-v2/overview-status-v2.component';
import { GenericErrorMessagesComponent } from './common/generic-error-messages/generic-error-messages.component';
import { TranslateModule } from '@ngx-translate/core';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { LayoutModule } from '@angular/cdk/layout';
import { faBiohazard, faPercent, faShip, faTemperatureLow } from '@fortawesome/free-solid-svg-icons';
import { FormFieldButtonComponent } from './dhl-form/components/form-field-button/form-field-button.component';
import { LocationDataV2Component } from './common/location-data-v2/location-data-v2.component';
import { OrderDataMessageComponent } from './common/order-data-message/order-data-message.component';
import { AdditionalInformationV2Component } from './dhl-form/components-v2/additional-information-v2/additional-information-v2.component';
import { WeeklyOperationalHoursV2Component } from './dhl-form/components-v2/weekly-operational-hours-v2/weekly-operational-hours-v2.component';
import { TableSimpleV2Component } from './common/table-simple-v2/table-simple-v2.component';
import { FormFieldRadioButtonV2Component } from './dhl-form/components-v2/form-field-radio-button-v2/form-field-radio-button-v2.component';
import { FormFieldNumberV2Component } from './dhl-form/components-v2/form-field-number-v2/form-field-number-v2.component';
import { BannerMessageComponent } from './common/banner-message/banner-message.component';
import { SafeHtmlPipe } from '../common/safeHtml.pipe';
import { GenericWarningMessageComponent } from './common/generic-warning-message/generic-warning-message.component';
import { ShipmentHistoryV2Component } from './common/shipment-history-v2/shipment-history-v2.component';
import { GenericTabsV2Component } from './dhl-form/components-v2/generic-tabs-v2/generic-tabs-v2.component';
import { TextHighlightPipe } from '../common/highlightText.pipe';
import { GenericInlineMessagesComponent } from './common/generic-inline-messages/generic-inline-messages.component';
import { RemoveTextPipe } from '../common/removeText.pipe';
import { GenericNotesV3Component } from './dhl-form/components-v2/generic-notes-v3/generic-notes-v3.component';
import { StripEmailPipe } from '../common/strip-email.pipe';
import { YesNoPipe } from '../common/yes-no.pipe';
import { DHLSimpleSelect } from './common/simple-select-input/simple-select-input.component';
import { DHLSimpleInput } from './common/simple-text-input/simple-text-input.component';
import { HeaderInfoComponent } from './common/header-info/header-info.component';
import { FormFieldToggleGroupV2Component } from './dhl-form/components-v2/form-field-toggle-group-v2/form-field-toggle-group-v2.component';
import { ConvertUomPipe } from '../common/convert-uom.pipe'
import { GenericFormFilterV3Component } from './common/generic-form-filter-v3/generic-form-filter-v3.component';
import { FormFieldTextComponent } from './dhl-form/components-v2/form-field-text/form-field-text.component';
import { FormFieldDaterangepickerV2Component } from './dhl-form/components-v2/form-field-daterangepicker-v2/form-field-daterangepicker-v2.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { IsEllipsisActiveDirective } from './dhl-form/directives/is-ellipsis-active.directive';
import { FormCompComponent } from './dhl-form/components/form-comp/form-comp.component';
import { JsonEditorComponent } from 'ang-jsoneditor' 
import { ProgressSpinnerV2Component } from '../common/progress-spinner-v2/progress-spinner-v2.component';


@NgModule({
  declarations: [
    FormFieldInputComponent,
    FormFieldTableComponent,
    FormFieldDropDownComponent,
    FormFieldDatePickerComponent,
    FormFieldAutoCompleteComponent,
    FormSearchBoxComponent,
    FormTableListComponent,
    FormDialogBoxComponent,
    SnackBarComponent,
    FormFieldHiddenComponent,
    ModalComponent,
    FormComponent,
    FormFieldComponent,
    FormFieldCardComponent,
    FormFieldSlideToggleComponent,
    FormFieldFilterComponent,
    HereMapComponent,
    CheckErrorPipe,
    AppOrderFilterComponent,
    FormFieldButtonComponent,
    FormFieldButtonToggleComponent,
    FormFieldWrapperComponent,
    FormFieldChipsAutocompleteComponent,
    FormFieldLocationComponent,
    FormFieldFileUploadComponent,
    FormFieldFileDownloadComponent,
    AppExtendWidthHeightDirective,
    FormTableComponent,
    FormFieldDaterangepickerV2Component,
    VerticalStepperComponent,
    FormFieldInputV2Component,
    FormFieldToggleSwitchV2Component,
    FormFieldSpaceholderV2Component,
    FormFieldTextareaV2Component,
    HorizontalStepperV2Component,
    StepperContentComponent,
    SearchBoxV2Component,
    GenericTableV2Component,
    FormFieldDropdownMultiChoiceV2Component,
    FormFieldDropdownMultiOptionIconV2Component,
    FormFieldInputDirective,
    FormFieldDropdownDirective,
    GenericFilterV2Component,
    GenericFormFilterV2Component,
    GenericFormFilterV3Component,
    ProgressIndicatorV2Component,
    FormFieldDropdownDefaultV2Component,
    FormFieldDatepickerV2Component,
    FormFieldDatepickerV2Directive,
    FormFieldGenericV2Component,
    FormFieldGenericDirective,
    FormFieldDateRangeV2Component,
    DatepickerFilterV2Component,
    FormFieldTableV2Component,
    FormFieldLocationV2Component,
    FormFieldAutocompleteV2Component,
    FormFieldAutocompleteV2Directive,
    FormFieldAutoPoItemcompleteV2Component,
    SubformComponent,
    GenericAccordionV2Component,
    GenericAccordionGroupV2Component,
    FormFieldLocationAutocompleteV2Component,
    GenericFormFieldGroupV2Component,
    FormFieldOrderLineAutocompleteComponent,
    GenericModalV2Component,
    FormFieldReadonlyV2Component,
    FormFieldTextComponent,
    OverviewV2Component,
    FormFieldGenericAutocompleteV2Component,
    FormSectionV2Component,
    FormFieldDropdownSimpleV2Component,
    FormFieldCheckboxV2Component,
    FormFieldDropdownMultiselectV2Component,
    GenericNotesV2Component,
    GenericNotesV3Component,
    OverviewItemV2Component,
    OverviewLocationV2Component,
    OverviewGenericV2Component,
    OverviewStatusV2Component,
    GenericErrorMessagesComponent,
    FormFieldButtonComponent,
    LocationDataV2Component,
    OrderDataMessageComponent,
    AdditionalInformationV2Component,
    TableSimpleV2Component,
    WeeklyOperationalHoursV2Component,
    BannerMessageComponent,
    FormFieldNumberV2Component,
    FormFieldRadioButtonV2Component,
    GenericInlineMessagesComponent,
    SafeHtmlPipe,
    GenericWarningMessageComponent,
    GenericTabsV2Component,
    HeaderInfoComponent,
    RemoveTextPipe,
    ShipmentHistoryV2Component,
    ConvertUomPipe,
    TextHighlightPipe,
    HeaderInfoComponent,
    YesNoPipe,
    StripEmailPipe,
    DHLSimpleInput,
    DHLSimpleSelect,
    FormFieldToggleGroupV2Component,
    IsEllipsisActiveDirective,
    FormCompComponent,
    ProgressSpinnerV2Component
  ],
  imports: [
    CommonModule,
    DemoMaterialModule,
    ReactiveFormsModule,
    LayoutModule,
    FlexLayoutModule,
    FontAwesomeModule,
    FormsModule,
    TranslateModule,
    NgxDaterangepickerMd.forRoot(),
    JsonEditorComponent
  ],
  exports: [
    FormFieldDaterangepickerV2Component,
    FormFieldInputComponent,
    FormFieldTableComponent,
    FormFieldDropDownComponent,
    FormFieldDatePickerComponent,
    FormFieldAutoCompleteComponent,
    FormSearchBoxComponent,
    FormTableListComponent,
    FormDialogBoxComponent,
    SnackBarComponent,
    FormFieldHiddenComponent,
    ModalComponent,
    FormComponent,
    FormFieldComponent,
    FormFieldCardComponent,
    FormFieldSlideToggleComponent,
    FormFieldFilterComponent,
    HereMapComponent,
    CheckErrorPipe,
    AppOrderFilterComponent,
    FormFieldFileDownloadComponent,
    VerticalStepperComponent,
    DemoMaterialModule,
    CommonModule,
    ReactiveFormsModule,
    LayoutModule,
    FlexLayoutModule,
    FontAwesomeModule,
    FormsModule,
    TranslateModule,
    FormFieldInputV2Component,
    FormFieldToggleSwitchV2Component,
    FormFieldSpaceholderV2Component,
    FormFieldTextareaV2Component,
    HorizontalStepperV2Component,
    SearchBoxV2Component,
    GenericTableV2Component,
    FormFieldDropdownMultiChoiceV2Component,
    FormFieldDropdownMultiOptionIconV2Component,
    GenericFilterV2Component,
    GenericFormFilterV2Component,
    GenericFormFilterV3Component,
    ProgressIndicatorV2Component,
    FormFieldDropdownDefaultV2Component,
    FormFieldGenericV2Component,
    DatepickerFilterV2Component,
    FormFieldDateRangeV2Component,
    FormFieldTableV2Component,
    FormFieldLocationV2Component,
    FormFieldAutocompleteV2Component,
    FormFieldLocationAutocompleteV2Component,
    FormFieldAutocompleteV2Directive,
    FormFieldAutoPoItemcompleteV2Component,
    GenericAccordionV2Component,
    FormFieldOrderLineAutocompleteComponent,
    GenericFormFieldGroupV2Component,
    GenericModalV2Component,
    FormFieldReadonlyV2Component,
    FormFieldTextComponent,
    FormFieldGenericAutocompleteV2Component,
    OverviewV2Component,
    FormSectionV2Component,
    FormFieldDropdownSimpleV2Component,
    FormFieldDropdownMultiselectV2Component,
    GenericNotesV2Component,
    GenericErrorMessagesComponent,
    FormFieldDatepickerV2Component,
    WeeklyOperationalHoursV2Component,
    LocationDataV2Component,
    BannerMessageComponent,
    GenericInlineMessagesComponent,
    SafeHtmlPipe,
    GenericWarningMessageComponent,
    OrderDataMessageComponent,
    ShipmentHistoryV2Component,
    GenericTabsV2Component,
    RemoveTextPipe,
    YesNoPipe,
    StripEmailPipe,
    DHLSimpleInput,
    DHLSimpleSelect,
    ConvertUomPipe,
    FormFieldToggleGroupV2Component,
    FormFieldRadioButtonV2Component,
    FormFieldNumberV2Component,
    TextHighlightPipe,
    ProgressSpinnerV2Component
  ],
  providers: []
})
export class SharedModule {
  constructor(private library: FaIconLibrary) {
    library.addIcons(faBiohazard, faTemperatureLow, faPercent, faShip
    );
  }
}